/* eslint-disable jsx-a11y/alt-text */
import { Link } from "react-router-dom";

import React, { useRef, useState } from "react";
import Modal from "./Modal";

const ModalPayFood = ({ toogleModeAddCart, setToogleModeAddCart, data }) => {
  const modeEl = useRef();
  const [social, setSocial] = useState(
    "https://www.facebook.com/profile.php?id=100028980550225"
  );

  const handleOffModeAddCart = (e) => {
    if (e.target === modeEl.current) {
      setToogleModeAddCart(false);
    }
  };
  return (
    <div>
      <Modal>
        {toogleModeAddCart && (
          <div className="overflow">
            <div
              className="fixed top-0 right-0 left-0 bottom-0 flex justify-center smooth px-2 sm:px-0"
              ref={modeEl}
              onClick={handleOffModeAddCart}
            >
              <div className="rounded-md mt-[40%] sm:mt-[10%] border-primary border-[1px] text-[15px] h-fit bg-white w-full  sm:w-[420px] relative">
                <div className="font-bold bg-primary flex gap-1 p-2 items-center text-white">
                  <i class="fa-solid fa-check mr-2"></i>
                  <span>Thông tin món ăn</span>
                </div>

                <div className="flex p-[10px] border-primary border-b">
                  <div className="w-[70px] mr-4">
                    <img className="rounded-md" src={data?.img}></img>
                  </div>
                  <div className="font-semibold ">
                    <span className="font-bold">{data.name}</span>
                    <span className="text-primary block">
                      {data?.price.toLocaleString()}₫
                    </span> 
                  </div>
                </div>

                <div>
                  <span className="text-sm p-2 inline-block font-semibold">
                    Vui lòng chọn phương thức mua hàng:
                  </span>
                  <div className="ml-4">
                    <div className="flex gap-2 items-center mb-3">
                      <input
                        onChange={(e) => setSocial(e.target.value)}
                        className="block  w-4 h-4"
                        type="checkbox"
                        checked={
                          social ===
                          "https://www.facebook.com/profile.php?id=100028980550225"
                        }
                        value="https://www.facebook.com/profile.php?id=100028980550225"
                      />
                      <Link
                        className="underline italic"
                        to={
                          "https://www.facebook.com/profile.php?id=100028980550225"
                        }
                      >
                        facebook-xuantruong.com
                      </Link>
                    </div>
                    <div className="flex gap-2 items-center mb-3">
                      <input
                        onChange={(e) => setSocial(e.target.value)}
                        className="block  w-4 h-4"
                        type="checkbox"
                        checked={
                          social ===
                          "https://www.facebook.com/profile.php?id=61559704733274"
                        }
                        value="https://www.facebook.com/profile.php?id=61559704733274"
                      />
                      <Link
                        className="underline italic"
                        to={
                          "https://www.facebook.com/profile.php?id=61559704733274"
                        }
                      >
                        facebook-ẩmthựchảidương.com
                      </Link>
                    </div>
                    <div className="flex gap-2 items-center mb-3">
                      <input
                        onChange={(e) => setSocial(e.target.value)}
                        className="block w-4 h-4"
                        type="checkbox"
                        checked={social === "https://zalo.me/0565442171"}
                        value="https://zalo.me/0565442171"
                      />
                      <Link
                        className="underline italic"
                        to={"https://zalo.me/0584564666"}
                      >
                        https://zalo.me-xuan-truong.com
                      </Link>
                    </div>
                  </div>
                </div>

                <div className="flex p-2 gap-2 mb-2">
                  <button
                    onClick={() => setToogleModeAddCart(false)}
                    className="p-1 flex-1 h-[36px] border-[1px] border-primary hover:bg-primary cursor-pointer 
                 rounded-lg text-white bg-black"
                  >
                    Tiếp tục mua hàng
                  </button>
                  <Link
                    to={social}
                    className="p-1 flex-1 h-[36px] border-[1px] border-primary hover:bg-black cursor-pointer 
                 rounded-lg text-white bg-primary flex-center"
                  >
                    Đặt hàng ngay
                  </Link>
                </div>
                <div
                  className="absolute top-0 right-0 p-[8px] -mt-[3px] text-white cursor-pointer hover:text-black"
                  onClick={() => setToogleModeAddCart(false)}
                >
                  <i class="fa-solid fa-xmark mr-1 text-xl"></i>
                </div>
              </div>
            </div>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ModalPayFood;
